import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { useLoadingDelay as l } from "@givebutter/react-util";
import { Loader as c } from "../loader/Loader.js";
import { twMerge as d } from "tailwind-merge";
const y = ({
  isLoading: r,
  size: i = "xl",
  delay: o,
  children: t,
  className: s,
  ...a
}) => {
  const { isLoading: n } = l(r, o);
  return /* @__PURE__ */ m("div", { className: d("relative", s), ...a, children: [
    t,
    n && /* @__PURE__ */ e("div", { className: "absolute inset-0 flex items-center justify-center bg-gray-50 opacity-70", children: /* @__PURE__ */ e(c, { size: i }) })
  ] });
};
export {
  y as LoadingOverlay
};
